<template>
  <div class="shell-page">
    <HeaderMain />

    <section class="legal-shell">
      <div class="glass-surface legal-card">
        <div class="section-heading">
          <span class="section-heading__eyebrow">Datos y privacidad</span>
          <h1 class="section-heading__title">Politica de privacidad</h1>
          <p class="section-heading__text">
            Asi tratamos la informacion necesaria para registro, compra de entradas, soporte, prevencion de fraude y operacion de la plataforma.
          </p>
        </div>

        <div class="legal-card__content">
          <section class="legal-page__highlight">
            <span class="legal-page__pill">Responsable</span>
            <h2 class="legal-page__highlight-title">Proteccion de datos aplicada al servicio FOMOPLANES</h2>
            <p>
              FOMOPLANES es operado por GINGO ENTERPRISES LLC. Direccion comercial registrada: 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110, Estados Unidos.
            </p>
            <p>
              Para consultas de privacidad puedes escribir a <a class="legal-page__text-link" href="mailto:fomoplanes@sudenec.com">fomoplanes@sudenec.com</a>.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>1. Informacion que recopilamos</h2>
            <p>
              Podemos recopilar nombre, apellido, correo electronico, telefono, direccion de facturacion, datos del pedido, datos de asistentes, historial de compras y cualquier informacion adicional que el evento solicite para emitir o validar accesos.
            </p>
            <p>
              Tambien podemos recopilar datos tecnicos razonables de navegacion, dispositivo, geolocalizacion aproximada, cookies, identificadores de sesion y registros de actividad para seguridad, analitica y funcionamiento del sitio.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>2. Para que usamos la informacion</h2>
            <p>
              GINGO ENTERPRISES LLC utiliza la informacion para crear cuentas, confirmar pagos, emitir tickets, atender soporte, notificar cambios de eventos, prevenir fraude, cumplir obligaciones legales y mejorar la experiencia de compra en FOMOPLANES.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>3. Pagos y procesadores externos</h2>
            <p>
              Los pagos pueden procesarse mediante Stripe y otros procesadores autorizados segun el evento y el metodo disponible. GINGO ENTERPRISES LLC no almacena datos completos de tarjetas de credito o debito en sus propios sistemas para FOMOPLANES.
            </p>
            <p>
              Cada procesador puede aplicar sus propias verificaciones, medidas antifraude, autenticaciones reforzadas y obligaciones regulatorias sobre la operacion.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>4. Con quien compartimos informacion</h2>
            <p>
              GINGO ENTERPRISES LLC puede compartir informacion con organizadores del evento, procesadores de pago, proveedores de tecnologia, servicios de correo, herramientas de analitica, servicios antifraude y autoridades competentes cuando exista base legal o necesidad operativa legitima.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>5. Conservacion y seguridad</h2>
            <p>
              GINGO ENTERPRISES LLC conserva la informacion durante el tiempo razonablemente necesario para operar la cuenta, emitir accesos, resolver disputas, atender reembolsos, cumplir obligaciones fiscales o regulatorias y resguardar evidencia de transacciones.
            </p>
            <p>
              GINGO ENTERPRISES LLC aplica medidas tecnicas y operativas razonables para proteger la informacion; sin embargo, ninguna transmision o almacenamiento digital puede garantizar seguridad absoluta.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>6. Tus consultas y solicitudes</h2>
            <p>
              Si deseas consultar, actualizar o corregir informacion asociada a tu cuenta o a una compra, contactanos desde el correo vinculado al pedido y adjunta el numero de orden o los datos del evento para ubicar tu caso mas rapido.
            </p>
          </section>

          <div class="legal-page__actions">
            <router-link :to="{ name: 'terms' }">Terminos y condiciones</router-link>
            <router-link :to="{ name: 'refunds' }">Reembolsos y cancelaciones</router-link>
            <router-link :to="{ name: 'contact' }">Contacto</router-link>
            <router-link :to="{ name: 'company' }">Compania</router-link>
          </div>
        </div>
      </div>
    </section>

    <FooterMain />
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'PrivacyView',
  components: {
    HeaderMain,
    FooterMain,
  },
}
</script>

<style>
</style>
